export async function t(fieldId: string, placeholder: string, multiline: boolean, hasError: boolean, value: string = null, onChange: ((value: string) => void) = null) {

    await import('@syncfusion/ej2-base/styles/bootstrap4.css');
    await import('@syncfusion/ej2-inputs/styles/bootstrap4.css');

    await import('./loadSyncfusion');

    const { TextBox } = await import('@syncfusion/ej2-inputs');

    const containerEle = document.getElementById('container_' + fieldId);
    const inputEle = document.getElementById('input_' + fieldId);

    if (containerEle.hasAttribute("data-textbox")) {
        // When a callback owner is wired (the response forms), do NOT reset ej2.value on re-init:
        // the container is hx-preserve'd, so the widget keeps the guest's in-flight text across a
        // conditional-refresh morph (e.g. a dropdown auto-submit). Resetting to the server's @Value
        // was wiping unsaved text — the field-clear bug. Legacy callers without onChange (menu
        // builders) keep the original re-push-server-value behaviour.
        if (!onChange) {
            var element: any = inputEle;
            var ej2 = element.ej2_instances[0];
            ej2.value = value;
        }
        (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
        return;
    }

    containerEle.setAttribute('data-textbox', 'true');

    let ddObject = new TextBox({
        // sets the placeholder
        floatLabelType: "Never",
        value: value,
        placeholder: null,
        multiline: multiline,
        created: (args: any) => {
            (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
            containerEle.style.display = null;
        },
        // Mirror the numeric field: sync the live value into the posted hidden input on every
        // keystroke/blur so a sibling control's auto-submit posts the current text (no data loss).
        input: (args: any) => {
            if (onChange) onChange(args.value);
        },
        change: (args: any) => {
            if (onChange) onChange(args.value);
        }
    });
    ddObject.appendTo('#input_' + fieldId);
}
